
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Découvrez la Définition de Merch: Un Guide Complet pour Entreprises et Consommateurs",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez la définition merch, allez au cœur du sujet, explorez la signification et la pertinence de ce terme populaire dans le monde du marketing et du commerce.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Découvrez la Définition de Merch: Un Guide Complet pour Entreprises et Consommateurs",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez la définition merch, allez au cœur du sujet, explorez la signification et la pertinence de ce terme populaire dans le monde du marketing et du commerce.",
        },
      ],
    };
  },
};
